/* eslint-disable  react/display-name*/
import { Button, IconButton, Tooltip, Grid } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RefreshIcon from "@mui/icons-material/Refresh";
import db from "../../db/db";
import MUIDataTable from "mui-datatables";
import React, { useEffect, useState } from "react";
import API from "../../utils/API";
import PromotionCrud from "./PromotionCrud";
import { useTranslation } from "react-i18next";
import { StringUtils } from "../../utils/StringUtils";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

export default function PromotionList(props) {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [rowLimitPerPage, setRowLimitPerPage] = useState(
    Math.round((getWindowDimensions().height - 345) / 26)
  );
  const { t } = useTranslation();
  const translate = t;

  const options = {
    serverSide: true,
    filterType: "dropdown",
    viewColumns: false,
    download: false,
    filter: false,
    selectableRowsHeader: false,
    selectableRowsHideCheckboxes: true,
    tableBodyMaxHeight: "100%",
    tableBodyHeight: getWindowDimensions().height - 225,
    rowsPerPage: rowLimitPerPage,
    rowsPerPageOptions: [rowLimitPerPage, 10, 15, 50, 100],

    print: false,
    onTableChange: (action, tableState) => {
      // a developer could react to change on an action basis or
      // examine the state as a whole and do whatever they want

      switch (action) {
        case "changePage":
          onTableChange(tableState);
          break;
        case "sort":
          onTableChange(tableState);
          break;
        case "changeRowsPerPage":
          onTableChange(tableState);
          break;
        case "search":
          onTableChange(tableState);
          break;
        default:
        //console.log("action not handled." + action);
      }
    },
    customToolbar: () => {
      return (
        <React.Fragment>
          <Tooltip title={"Refresh Data"}>
            <IconButton
              size="small"
              color="primary"
              onClick={promotionListRefresh}
            >
              <RefreshIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title={"Add New Promotion"}>
            <IconButton size="small" color="secondary" onClick={onAddClicked}>
              <AddIcon />
            </IconButton>
          </Tooltip>
        </React.Fragment>
      );
    },
  };
  const [option, setOption] = useState(options);

  useEffect(() => {
    loadData();
  }, []);

  function onAddClicked() {
    biRef.child.showPromotionCrudWindow(null);
  }

  function onEditClicked(row) {
    biRef.child.showPromotionCrudWindow(row.tableData[row.rowIndex]._id.$oid);
  }

  async function loadData() {
    let sort = '[{id:"fromDate","sortOrder":"asc"}]';
    loadByRest(0, rowLimitPerPage, sort, "[]");
    //loaadByDB();
  }
  async function loadByRest(curPage, pageSize, sort, filter) {
    setIsLoading(true);
    const result = await API.get(
      "/api/v1/promotions?range=" +
        encodeURIComponent(
          "[" + curPage * pageSize + "," + ((curPage + 1) * pageSize - 1) + "]"
        ) +
        "&filter=" +
        encodeURIComponent(filter) +
        "&sort=" +
        encodeURIComponent(sort)
    );

    var arr = result.data.contentRange.split("/");
    const opt = { ...option };
    opt.count = parseInt(arr[2]);
    setOption(opt);
    setData(result.data.data);
    setIsLoading(false);
  }
  async function loaadByDB() {
    db.tax.toArray(function (data) {
      setData(data);
    });
  }

  async function onTableChange(tableState) {
    console.log(tableState.sortOrder);
    let sort = "[]";
    if (tableState.sortOrder.name) {
      sort =
        '[{id:"' +
        tableState.sortOrder.name +
        '",desc:' +
        (tableState.sortOrder.direction === "desc" ? "true}]" : "false}]");
    }
    if (tableState.sortOrder.name) {
      sort =
        '[{id:"' +
        tableState.sortOrder.name +
        '",desc:' +
        (tableState.sortOrder.direction === "desc" ? "true}]" : "false}]");
    }
    let search = "[]";
    if (tableState.searchText) {
      let str = "[";
      str =
        str +
        '{id:"policyName",value:"",regExp:".*(?i)' +
        tableState.searchText +
        '.*",matchType:"BROAD_MATCH",operatorType:"",fieldValueType:"string","conditionType":"or"}';

      //str = str + ',{id:"code",value:"' + tableState.searchText + '"}';

      str = str + "]";
      search = str;
    }
    loadByRest(tableState.page, tableState.rowsPerPage, sort, search);
  }

  const columns = [
    {
      name: "policyName",
      label: "Name",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "policyMode",
      label: "Policy Mode",
      options: {
        filter: false,
        sort: false,
        display: "true",
        setCellHeaderProps: () => ({
          align: "left",
          "@media only screen and (max-width: 600px)": {},
        }),
        setCellProps: () => ({ align: "left" }),
        customBodyRender: (value, tableMeta, updateValue) =>
          tableMeta.tableData[tableMeta.rowIndex].policyMode.name,
      },
    },
    {
      name: "fromDate",
      label: "Start Date",
      options: {
        filter: false,
        sort: false,
        display: "true",
        setCellHeaderProps: () => ({
          align: "left",
          "@media only screen and (max-width: 600px)": {},
        }),
        setCellProps: () => ({ align: "left" }),
        customBodyRender: (value, tableMeta, updateValue) => {
          return StringUtils.formatDate(new Date(value.$date), 1);
        },
        // customBodyRender: (value, tableMeta, updateValue) =>
        //   new Date(
        //     tableMeta.tableData[tableMeta.rowIndex].fromDate
        //   ).toLocaleDateString([], {
        //     year: "numeric",
        //     month: "long",
        //     day: "numeric",
        //   }),
      },
    },
    {
      name: "toDate",
      label: "End Date",
      options: {
        filter: false,
        sort: false,
        display: "true",
        setCellHeaderProps: () => ({
          align: "left",
          "@media only screen and (max-width: 600px)": {},
        }),
        setCellProps: () => ({ align: "left" }),
        customBodyRender: (value, tableMeta, updateValue) => {
          return StringUtils.formatDate(new Date(value.$date), 1);
        },
        // customBodyRender: (value, tableMeta, updateValue) =>
        //   new Date(
        //     tableMeta.tableData[tableMeta.rowIndex].toDate
        //   ).toLocaleDateString([], {
        //     year: "numeric",
        //     month: "long",
        //     day: "numeric",
        //   }),
      },
    },

    {
      name: "ruleType",
      label: "Rule Type",
      options: {
        filter: false,
        sort: false,
        display: "true",
        setCellHeaderProps: () => ({
          align: "left",
          "@media only screen and (max-width: 600px)": {},
        }),
        setCellProps: () => ({ align: "left" }),
        customBodyRender: (value, tableMeta, updateValue) =>
          tableMeta.tableData[tableMeta.rowIndex].ruleConfigList[0].ruleType
            .name,
      },
    },

    {
      name: "action",
      label: "Actions",
      options: {
        filter: false,
        sort: false,
        display: "true",
        setCellHeaderProps: () => ({
          align: "right",
          "@media only screen and (max-width: 600px)": {},
        }),
        setCellProps: () => ({ align: "right" }),
        customBodyRender: (value, tableMeta, updateValue) => (
          <Button
            onClick={() => onEditClicked(tableMeta, updateValue, value)}
            color="secondary"
            style={{
              margin: 0,
              padding: 0,
              height: 17,
              width: 27,
              alignText: "right",
            }}
          >
            {props.context.privileges.promotion_edit
              ? translate("Edit")
              : translate("view")}
          </Button>
        ),
      },
    },
  ];

  function promotionListRefresh() {
    loadData();
  }

  var biRef = {};

  return (
    <Grid containter>
      <Grid item xs={12}>
        <div>
          <MUIDataTable
            title={"Promotion List"}
            data={data}
            columns={columns}
            options={option}
          />
        </div>
      </Grid>
      <PromotionCrud
        biRef={biRef}
        showMessage={props.showMessage}
        onRefresh={promotionListRefresh}
        context={props.context}
      ></PromotionCrud>
    </Grid>
  );
}
